import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';
import {authLoader} from '../../loader';
import {ROUTE_SECONDARY_BRAND_ALLOCATION_APPROVAL} from '@app/navigations/RoutePathConstant';

const SecondaryBrandAllocationApproval = lazy(() =>
  import('../../../screens/SecondaryBrandAllocationApproval')
    .then(module => ({default: module.SecondaryBrandAllocationApproval})));

const SecondaryBrandAllocationApprovalNavigation = [
  {
    path: ROUTE_SECONDARY_BRAND_ALLOCATION_APPROVAL,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <SecondaryBrandAllocationApproval />
      </Suspense>
    ),
  },
];

export default SecondaryBrandAllocationApprovalNavigation;
